import "./App.css";

const BarkerLabsPage = () => {
  return (
    <div className="bg-white min-h-screen">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="barkerlabs-container">
          <h1 className="hero-title">Barker Labs</h1>
          <p className="hero-subheading">
            A showcase of apps you can use, play, and explore.
          </p>
          <p className="hero-supporting">
            Pick what looks interesting and try it.
          </p>
        </div>
      </section>

      {/* Divider */}
      <div className="barkerlabs-container">
        <hr className="divider" />
      </div>

      {/* Apps Section */}
      <section className="products-section">
        <div className="barkerlabs-container">
          <div className="products-list">
            {/* PinnixAI */}
            <div className="product-item">
              <h3 className="product-title">PinnixAI</h3>
              <div className="product-description">
                <p className="product-description-line">
                  Your personal AI strength & conditioning coach for martial artists.
                </p>
                <p className="product-description-line">Get daily workouts.</p>
                <p className="product-description-line">Train for events.</p>
              </div>
              <a 
                href="https://pinnixai.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="product-link"
              >
                Visit PinnixAI.com →
              </a>
            </div>

            {/* Ultimate Movie Trivia */}
            <div className="product-item">
              <h3 className="product-title">Ultimate Movie Trivia</h3>
              <div className="product-description">
                <p className="product-description-line">
                  A competitive trivia game for movie fans.
                </p>
                <p className="product-description-line">Play daily challenges.</p>
                <p className="product-description-line">Battle friends.</p>
                <p className="product-description-line">Climb the leaderboard.</p>
              </div>
              <a 
                href="https://ultimatemovietrivia.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="product-link"
              >
                Visit UltimateMovieTrivia.com →
              </a>
            </div>

            {/* Sports Trivia */}
            <div className="product-item">
              <h3 className="product-title">Sports Trivia (Coming Soon)</h3>
              <div className="product-description">
                <p className="product-description-line">
                  Trivia built for sports fans.
                </p>
                <p className="product-description-line">Compete head-to-head.</p>
                <p className="product-description-line">Test your knowledge.</p>
                <p className="product-description-line">Track your score.</p>
              </div>
              <p className="product-status">Coming Soon</p>
            </div>

            {/* Bible Trivia */}
            <div className="product-item">
              <h3 className="product-title">Bible Trivia (Coming Soon)</h3>
              <div className="product-description">
                <p className="product-description-line">
                  A simple and fun way to learn the Bible.
                </p>
                <p className="product-description-line">Play quizzes.</p>
                <p className="product-description-line">Grow your knowledge.</p>
                <p className="product-description-line">Challenge yourself.</p>
              </div>
              <p className="product-status">Coming Soon</p>
            </div>

            {/* Finance Tools */}
            <div className="product-item">
              <h3 className="product-title">Finance Tools (Coming Soon)</h3>
              <div className="product-description">
                <p className="product-description-line">
                  Simple tools to help people manage money better.
                </p>
                <p className="product-description-line">Track spending.</p>
                <p className="product-description-line">Set goals.</p>
                <p className="product-description-line">Build long-term habits.</p>
                <p className="product-description-line">Clear systems.</p>
                <p className="product-description-line">No confusion.</p>
              </div>
              <p className="product-status">Coming Soon</p>
            </div>

            {/* Poway Martial Arts Members App */}
            <div className="product-item">
              <h3 className="product-title">Poway Martial Arts Members App (Private)</h3>
              <div className="product-description">
                <p className="product-description-line">
                  A members app built for martial arts schools.
                </p>
                <p className="product-description-line">
                  Helps students stay organized and stay consistent.
                </p>
              </div>
              <p className="product-status">Private</p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="barkerlabs-container">
        <hr className="divider" />
      </div>

      {/* Footer */}
      <footer className="footer-section">
        <div className="barkerlabs-container">
          <p className="footer-copyright">© 2026 Barker Labs</p>
          <p className="footer-builder">Built by Justin Barker</p>
          <p className="footer-contact">
            Contact: <a href="mailto:hello@barkerlabs.io">hello@barkerlabs.io</a>
          </p>
        </div>
      </footer>
    </div>
  );
};

function App() {
  return <BarkerLabsPage />;
}

export default App;
